import axios from 'axios';
import { getToken } from '@/utils/auth'
import { Message} from 'element-ui'

let baseUrl = process.env.VUE_APP_BASE_API;



export let requestGet = function(url,params){
  const headers = {
    'Authorization': 'Bearer ' + getToken()
  };

  const axiosConfig = {
    headers: headers,
    params: params,
  };

  return new Promise((resolve, reject) => {
    axios.get(baseUrl + url, axiosConfig)
      .then(response => {
        // 请求成功时的处理
        const code = response.data.code || 200;
        if(code == 403){
          Message({ message: '当前操作没有权限', type: 'error' })
        }
        resolve(response.data);
      })
      .catch(error => {
        // 请求失败时的处理
        Message({ message: error, type: 'error' })
        reject(error);
      });
  })
}

export let requestPost = function(url,params){
  const headers = {
    'Content-Type': 'application/json', // 适应您的实际需求
    'Authorization': 'Bearer ' + getToken()
  };

  const axiosConfig = {
    headers: headers,
  };

  return new Promise((resolve, reject) => {
    axios.post(baseUrl + url, params, axiosConfig)
      .then(response => {
        // 请求成功时的处理
        const code = response.data.code || 200;
        if(code == 403){
          Message({ message: '当前操作没有权限', type: 'error' })
        }
        resolve(response.data);
      })
      .catch(error => {
        // 请求失败时的处理
        Message({ message: error, type: 'error' })
        reject(error);
      });
  })
}

export let requestFile = function(url,params) {
  return new Promise((resolve, reject) => {
    axios({
      url: baseUrl + url,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data' ,
        'Authorization': 'Bearer ' + getToken()
      }
    }).then(response => {
      // 请求成功时的处理
      resolve(response.data)
    })
      .catch(error => {
        // 请求失败时的处理
        reject(error)
      })
  })
}


export let resourceUrl = function(url,type) {
  if(!url){
    switch (type){
      case 'avatar':
        return require('@/static/img/avatar.jpg')
        break;
      case 'title':
        return require('@/static/img/title.jpg')
        break;
    }
  }
  return baseUrl + url;
}
